module.exports = __webpack_public_path__ + "static/media/header-ash.5cbcdc35.png";